import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import {
	GenerateAiDraftFromSocialPost,
	type GenerateAiDraftFromSocialPostMutation,
	type GenerateAiDraftFromSocialPostMutationVariables,
} from './api.graphql';

export async function generateAiDraftFromSocialPost(
	{ url, caption }: { url: string; caption: string | undefined },
	{ gql: { fetch } }: UtilityContext,
): Promise<GenerateAiDraftFromSocialPostMutation['generateAiDraftFromSocialPost']> {
	const { data, errors } = await fetch<
		GenerateAiDraftFromSocialPostMutation,
		GenerateAiDraftFromSocialPostMutationVariables
	>({
		query: GenerateAiDraftFromSocialPost,
		variables: { input: { promptOrUrl: url, caption } },
		// Must match the mutation's @restrictPath on the middle-end resolver.
		path: '/generate-ai-draft-from-social-post',
		rejectOnError: false,
		batched: false,
	});

	if (errors) throw new Error(JSON.stringify(errors));
	if (!data) throw new Error('Empty data in generateAiDraftFromSocialPost graphQL response');

	return data.generateAiDraftFromSocialPost;
}
